import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";

export function useRefreshGuard(
    methods: UseFormReturn<any>,
    setCoverPdfBlob: (value: React.SetStateAction<Blob | null>) => void,
    setContnetPdfBlob: (value: React.SetStateAction<Blob | null>) => void,
    setActiveStep: (value: React.SetStateAction<number>) => void,
    setLoading: (value: React.SetStateAction<boolean>) => void
) {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // 폼이 수정된 상태일 때만 경고창
      if (methods.formState.isDirty) {
        e.preventDefault();
        e.returnValue = "";     // 필수: 크롬·파폭 모두 빈 문자열
      }
    };

    const handleUnload = () => {
      // 사용자가 "예, 떠나기"를 결정했을 때만 호출
      if (methods.formState.isDirty) {
        // draft-id를 지워서 다음 로드 시 새 UUID 발급
        sessionStorage.removeItem("draft-id");
        const savedId = sessionStorage.getItem("draft-id");
        const draftId = savedId ?? crypto.randomUUID();
        if (!savedId) sessionStorage.setItem("draft-id", draftId);
        setCoverPdfBlob(null);
        setContnetPdfBlob(null);
        setActiveStep(0);
        setLoading(false);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);   // pagehide(모바일)도 OK

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("unload", handleUnload);
    };
  }, [methods.formState.isDirty]);
}
